
 import * as React from 'react';
 import {createComponent, EventName} from '@lit/react';
 
 import {ObcButton as ObcButtonElement} from '@oicl/openbridge-webcomponents/dist/components/button/button.js';
 
 
 

 
 export const ObcButton = createComponent({
   react: React,
   tagName: 'obc-button',
   elementClass: ObcButtonElement,
   events: {
     
     onClick: 'click' as EventName<CustomEvent<unknown>>,
   }
  });
 
 